import React, { FunctionComponent } from 'react';
import { AdminOrganizationDetails } from 'api';
import { FiltersWrapper } from 'ui/molecules/filtering';
import Translate from 'src/ui/atoms/translate';
import Header from 'src/ui/atoms/header';
import Section from 'src/ui/atoms/section';
import WideContent from 'src/core/layout/content/wide-content';
import { currentUserHasManageUsersAndGroupsPermission } from 'src/apps/issuer/helpers/userPermissions';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import { currentOrganizationHasManageUsersAndGroupsPermission } from 'src/apps/issuer/helpers/organizationPermissions';
import UsersTable from '../../../shared/users-table';

interface OrganizationUsersTableProps {
  organization: AdminOrganizationDetails;
  forceDataLoad?: boolean;
  defaultLimit?: number;
  goToDetails?: (userId: string) => void;
  setFilterPopupHeight?: (height: number) => void;
}

const OrganizationUsersTable: FunctionComponent<OrganizationUsersTableProps> = ({
  organization,
  setFilterPopupHeight,
  ...restProps
}) => {
  const { currentUser } = useCurrentUserSelector();

  const hasPermission =
    currentUserHasManageUsersAndGroupsPermission(currentUser?.permissions || []) ||
    currentOrganizationHasManageUsersAndGroupsPermission(organization);

  return (
    <Section>
      <WideContent>
        <Header size="small">
          <Translate name="issuerOrganizationsDetails.usersTable.title" />
        </Header>
        <UsersTable
          hasPermission={hasPermission}
          organizationId={organization.id}
          showOrganizationColumn={false}
          setFilterPopupHeight={setFilterPopupHeight}
          skipFilterUrlSync={true}
          {...restProps}
        />
      </WideContent>
    </Section>
  );
};

export default OrganizationUsersTable;
